<template>
  <div class="tw-w-full">
    <div class="tw-mb-1 tw-flex tw-items-center">
      <label v-if="label" class="tw-block tw-text-xs dark:tw-text-white">
        {{ label }}
      </label>
      <slot name="info" />
    </div>

    <div
      :id="id"
      :data-testid="id"
      class="tw-flex tw-h-10 tw-items-center tw-justify-between tw-overflow-hidden tw-rounded-md tw-border tw-p-1 focus-within:tw-border-deep-orange-500 focus-within:tw-outline-none focus-within:tw-ring-2 focus-within:tw-ring-deep-orange-500 hover:tw-border-deep-orange-500 sm:tw-text-sm"
    >
      <button
        class="tw-h-full tw-rounded tw-px-4 hover:tw-bg-deep-orange-500"
        :class="{
          'tw-cursor-not-allowed tw-opacity-50 hover:tw-bg-transparent': isMin
        }"
        :disabled="disabled || isMin"
        data-testid="studio-number-input-decrement-button"
        @click="decrementValue"
      >
        <Minus />
      </button>
      <span class="tw-flex tw-flex-row tw-justify-center">
        {{ `${currentValue} ${currentValue === 1 ? suffix.singular : suffix.plural}` }}
      </span>
      <button
        class="tw-h-full tw-rounded tw-px-4 hover:tw-bg-deep-orange-500"
        :class="{
          'tw-cursor-not-allowed tw-opacity-50 hover:tw-bg-transparent': isMax
        }"
        :disabled="disabled || isMax"
        data-testid="studio-number-input-increment-button"
        @click="incrementValue"
      >
        <Plus />
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import { Minus, Plus } from './Icons';

export default defineComponent({
  name: 'StudioNumberInput',
  components: {
    Minus,
    Plus
  },
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: Infinity
    },
    step: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    suffix: {
      type: Object,
      default: null,
      validator: function (value) {
        return Object.keys(value).includes('singular') && Object.keys(value).includes('plural');
      }
    }
  },
  data() {
    return {
      currentValue: parseInt(this.value, 10)
    };
  },
  computed: {
    isMax() {
      return this.currentValue === this.max;
    },
    isMin() {
      return this.currentValue === this.min;
    }
  },
  watch: {
    value(newValue) {
      this.currentValue = parseInt(newValue, 10);
    }
  },
  methods: {
    incrementValue() {
      if (this.value < this.max) {
        this.currentValue = this.currentValue + parseInt(this.step, 10);
      }

      this.$emit('change', this.currentValue);
    },
    decrementValue() {
      if (this.currentValue > this.min) {
        this.currentValue = this.currentValue - parseInt(this.step, 10);
      }

      this.$emit('change', this.currentValue);
    }
  }
});
</script>

<style lang="scss">
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
